import { GlobalConfig } from "@/types/config";

export const siteConfig: GlobalConfig = {
  name: "Helios",
  description:
    "Turn your leads into customers. Helios provides all the tools to help you craft perfect SMS campaigns and automate the rest.",
  url: "https://sendhelios.com",
  // Self-hosted: the old i.ibb.co copy was downscaled to 640x336 by the host.
  ogImage: "https://sendhelios.com/images/og.png",
  links: {
    twitter: "https://twitter.com/sendhelios",
  },
  mainNav: [
    {
      title: "Platform",
      href: "/features",
    },
    {
      title: "Pricing",
      href: "/pricing",
    },
    {
      title: "Resources",
      href: "/blog",
      subNav: [
        {
          title: "Blog",
          href: "/blog",
          description: "Playbooks and growth ideas for fitness brands.",
        },
        {
          title: "Help Center",
          href: "/help-center",
          description: "Guides and answers for getting the most from Helios.",
        },
      ],
    },
    {
      title: "Contact",
      href: "/contact",
    },
  ],
};
